<div>
  <div class="modal-header pb-3">
    <h4 class="modal-title fw-bold" id="modal-basic-title">Bulk Upload Rates</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <div class="modal-body pt-3">

    <!-- Wizard progress indicator -->
    <div class="d-flex align-items-center mb-4 px-2">
      <ng-container *ngFor="let step of steps; let i = index; let last = last">
        <div class="d-flex flex-column align-items-center text-center flex-shrink-0">
          <div class="rounded-circle d-flex align-items-center justify-content-center fw-semibold"
            style="width: 40px; height: 40px;"
            [ngClass]="activeStep >= i + 1 ? 'bg-secondary text-white' : 'bg-body-secondary text-muted'">
            <i class="bi bi-check-lg" *ngIf="activeStep > i + 1"></i>
            <span *ngIf="activeStep <= i + 1">{{ i + 1 }}</span>
          </div>
          <div class="mt-2 small fw-semibold text-nowrap" [ngClass]="activeStep >= i + 1 ? 'text-dark' : 'text-muted'">
            {{ step.label }}</div>
        </div>
        <div class="flex-grow-1 mx-2" style="height: 2px; margin-bottom: 1.85rem;" *ngIf="!last"
          [ngClass]="activeStep > i + 1 ? 'bg-secondary' : 'bg-body-secondary'"></div>
      </ng-container>
    </div>

    <form [formGroup]="rateForm">

      <!-- STEP 1: Select Category -->
      <div class="wizard-step" [class.active]="currentStep === 1 && !isPreviewed">
        <div class="text-uppercase fw-bold text-secondary small mb-2" style="letter-spacing: 0.04em;">Select Category
        </div>
        <div class="overflow-y-auto overflow-x-hidden p-1" style="max-height: 360px;">
          <div class="row g-3">
            <div class="col-12 col-md-6" *ngFor="let cat of categoryTypeArray">
              <div class="position-relative h-100 border rounded-3 p-3 cursor-pointer"
                [ngClass]="selectedCategoryID === cat.value ? 'border-secondary' : ''"
                [style.box-shadow]="selectedCategoryID === cat.value ? '0 0 0 1px var(--bs-secondary)' : null"
                (click)="onChangeCategory(cat)">
                <div class="d-flex align-items-center justify-content-center rounded-3 mb-3"
                  style="width: 48px; height: 48px;"
                  [ngClass]="selectedCategoryID === cat.value ? 'bg-secondary-subtle text-secondary' : 'bg-body-secondary text-secondary-emphasis'">
                  <i class="bi fs-4" [ngClass]="getCategoryIcon(cat.label)"></i>
                </div>
                <div class="fw-bold text-dark mb-1">{{ cat.label }}</div>
                <div class="text-muted small">{{ cat.description }}</div>
                <i class="bi bi-check-circle-fill text-secondary position-absolute fs-5" style="top: 1rem; right: 1rem;"
                  *ngIf="selectedCategoryID === cat.value"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 2: Select File -->
      <div class="wizard-step" [class.active]="currentStep === 2 && !isPreviewed">
        <div class="d-flex align-items-start bg-info-subtle border border-info-subtle rounded p-4 gap-3 w-100">
          <i class="bi bi-info-circle-fill text-info fs-3"></i>
          <div class="row gy-2 flex-grow-1">
            <div class="fw-bold">
              Download Template First
            </div>
            <div>
              Download the CSV template specific to <span class="fw-bold">{{selectedCategory.toLowerCase()}}</span> to
              ensure your file has the correct format.
            </div>
            <div>
              <button type="button" (click)="downloadTemplate()" class="btn btn-primary"><i
                  class="bi bi-download text-info text-sm me-2"></i>Download
                Template</button>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-start bg-light border rounded p-2 gap-3 w-100 mt-4">
          <div class="flex-grow-1 text-small">
            <span class="fw-bold">Category:</span> {{selectedCategory}}
          </div>
        </div>

        <div class="drag-area mt-4" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
          (drop)="onFileDrop($event)" [class.dragover]="isDragOver" [class.file-selected]="uploadedFile">

          <!-- Empty state -->
          <div class="text-center" *ngIf="!uploadedFile">
            <i class="bi bi-upload fs-1 text-secondary"></i>
            <p class="fw-bold mt-2 mb-0">Drag & drop your CSV file here, or click to browse</p>
            <p class="text-muted small mt-1">CSV files only</p>
          </div>

          <!-- File selected state -->
          <div class="text-center" *ngIf="uploadedFile">
            <i class="bi bi-file-earmark-spreadsheet fs-1 text-success"></i>
            <p class="fw-bold mt-2 mb-0">{{ uploadedFile.name }}</p>
            <p class="text-muted small mb-2">{{ formatFileSize(uploadedFile.size) }}</p>
            <a class="small text-secondary" style="cursor:pointer; position:relative; z-index:2;"
              (click)="clearFile(); $event.stopPropagation()">
              <i class="bi bi-x me-1"></i>Change file
            </a>
          </div>

          <input #fileInput type="file" accept=".csv" class="file-input" (change)="onFileSelect($event)">
        </div>

        <!-- Client-side file error -->
        <div class="mt-2 small text-danger" *ngIf="fileError">
          <i class="bi bi-exclamation-circle me-1"></i>{{ fileError }}
        </div>
      </div>

      <!-- STEP 3: Upload & Validate (progress + results all inline) -->
      <div class="wizard-step" [class.active]="isPreviewed">

        <!-- Processing state: show progress bar and phases inline -->
        <ng-container *ngIf="isProcessing">
          <div class="d-flex align-items-start gap-3 mb-3">
            <div
              class="d-flex align-items-center justify-content-center rounded-3 bg-secondary-subtle text-secondary flex-shrink-0"
              style="width: 48px; height: 48px;">
              <i class="bi bi-file-earmark-text fs-4"></i>
            </div>
            <div class="flex-grow-1 min-w-0">
              <div class="fw-bold text-truncate">{{ uploadedFile?.name }}</div>
              <div class="small text-muted">Processing &bull; {{ elapsedDisplay }} elapsed</div>
            </div>
            <div class="fw-bold text-secondary">{{ processingPercent }}%</div>
          </div>

          <div class="progress mb-4" style="height: 8px;">
            <div class="progress-bar bg-secondary" role="progressbar" [style.width.%]="processingPercent"
              [attr.aria-valuenow]="processingPercent" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="d-flex flex-column gap-2 mb-4">
            <div *ngFor="let phase of processingPhases; let i = index"
              class="d-flex align-items-center gap-3 rounded-3 p-3"
              [ngClass]="activeProcessingPhase === i ? 'bg-secondary-subtle' : ''">
              <div class="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style="width: 32px; height: 32px;"
                [ngClass]="i < activeProcessingPhase ? 'bg-success text-white' : activeProcessingPhase === i ? 'bg-secondary text-white' : 'border text-muted'">
                <i class="bi bi-check-lg"
                  *ngIf="i < activeProcessingPhase || (activeProcessingPhase === i && processingPercent === 100)"></i>
                <div class="spinner-border spinner-border-sm" role="status"
                  *ngIf="activeProcessingPhase === i && processingPercent < 100" aria-hidden="true"></div>
              </div>
              <div class="flex-grow-1">
                <div class="fw-bold" [ngClass]="activeProcessingPhase === i ? 'text-secondary' : 'text-dark'">{{
                  phase.label }}</div>
                <div class="small text-muted">{{ phase.description }}</div>
              </div>
              <div class="fw-bold text-secondary" *ngIf="activeProcessingPhase === i">{{ processingPercent }}%</div>
            </div>
          </div>

          <div class="alert alert-info border d-flex align-items-center gap-2 py-3 mb-0">
            <i class="bi bi-clock"></i>
            <span>Estimated time remaining: <strong>{{ estimatedMinutesRemaining }} minute{{ estimatedMinutesRemaining
                === 1 ? '' : 's' }}</strong></span>
          </div>

          <div *ngIf="showProcessingLog" class="border rounded-3 mt-3 p-3 bg-light">
            <div class="small text-muted mb-2 fw-semibold">Processing log</div>
            <div class="small text-muted" *ngFor="let log of processingLogs">{{ log }}</div>
          </div>
        </ng-container>

        <!-- Completed / Ready state: show results -->
        <ng-container *ngIf="!isProcessing">
          <div class="bg-light border rounded p-4 text-center">
            <i class="bi fs-1"
              [ngClass]="uploadCompleted ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-check-fill text-success'"></i>
            <h5 class="fw-bold mt-3">{{ uploadCompleted ? 'Upload Complete' : 'Ready to Upload' }}</h5>
            <p class="text-muted">{{ uploadCompleted ? 'Your rates have been uploaded successfully.' : 'File
              validation passed! Your rates are ready to be processed.' }}</p>

            <div class="d-flex justify-content-center gap-2 mt-4 flex-wrap">
              <div class="text-center px-3 border-end">
                <div class="fw-bold fs-4">{{previewData?.total_rows || 0}}</div>
                <div class="small text-muted text-uppercase">Total Rows</div>
              </div>
              <div class="text-center px-3 border-end text-success">
                <div class="fw-bold fs-4">{{(previewData?.created_rates || 0) + (previewData?.updated_rates || 0)}}
                </div>
                <div class="small text-muted text-uppercase">Valid Rates</div>
              </div>
              <div class="text-center px-3 border-end text-warning">
                <div class="fw-bold fs-4">{{previewData?.skipped_routes || 0}}</div>
                <div class="small text-muted text-uppercase">Skipped</div>
              </div>
              <div class="text-center px-3 border-end text-warning" *ngIf="previewData?.warnings?.length > 0">
                <div class="fw-bold fs-4">{{previewData?.warnings?.length || 0}}</div>
                <div class="small text-muted text-uppercase">Warnings</div>
              </div>
              <div class="text-center px-3 text-danger" *ngIf="previewData?.errors?.length > 0">
                <div class="fw-bold fs-4">{{previewData?.errors?.length || 0}}</div>
                <div class="small text-muted text-uppercase">Errors</div>
              </div>
            </div>
          </div>

          <!-- Detailed Tabs (Errors & Warnings) -->
          <div class="mt-4" *ngIf="previewData?.errors?.length > 0 || previewData?.warnings?.length > 0">
            <ul class="nav nav-tabs">
              <li class="nav-item" (click)="setActiveTab('errors')">
                <a class="nav-link cursor-pointer" [class.active]="activeTab === 'errors'"
                  [class.text-danger]="previewData?.errors?.length > 0">
                  Errors ({{previewData?.errors?.length || 0}})
                </a>
              </li>
              <li class="nav-item" (click)="setActiveTab('warnings')">
                <a class="nav-link cursor-pointer" [class.active]="activeTab === 'warnings'"
                  [class.text-warning]="previewData?.warnings?.length > 0">
                  Warnings ({{previewData?.warnings?.length || 0}})
                </a>
              </li>
            </ul>

            <div class="tab-content border border-top-0 rounded-bottom bg-white"
              style="max-height: 300px; overflow-y: auto;">
              <!-- Errors Panel -->
              <div class="tab-pane fade show active" *ngIf="activeTab === 'errors'">
                <div *ngIf="previewData?.errors?.length > 0; else noErrors">
                  <table class="table table-sm table-hover mb-0">
                    <thead class="bg-light sticky-top">
                      <tr>
                        <th class="px-3 py-2 text-center" style="width: 80px;">Row</th>
                        <th class="px-3 py-2">Problem Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let err of previewData.errors">
                        <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{err.row}}</td>
                        <td class="px-3 py-2 text-danger">{{err.error || err.message}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ng-template #noErrors>
                  <div class="p-4 text-center text-muted">No errors detected.</div>
                </ng-template>
              </div>

              <!-- Warnings Panel -->
              <div class="tab-pane fade show active" *ngIf="activeTab === 'warnings'">
                <div *ngIf="previewData?.warnings?.length > 0; else noWarnings">
                  <table class="table table-sm table-hover mb-0">
                    <thead class="bg-light sticky-top">
                      <tr>
                        <th class="px-3 py-2 text-center" style="width: 80px;">Row</th>
                        <th class="px-3 py-2">Warning Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let warn of previewData.warnings">
                        <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{warn.row}}</td>
                        <td class="px-3 py-2 text-warning">{{warn.message || warn.warning || warn.error}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <ng-template #noWarnings>
                  <div class="p-4 text-center text-muted">No warnings detected.</div>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

    </form>

  </div>

  <div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-outline-secondary px-4" (click)="closeModal()">Cancel</button>

    <div class="d-flex flex-row gap-3">
      <button class="btn btn-outline-secondary px-4"
        *ngIf="(currentStep != 1 || isPreviewed) && !uploadCompleted && !isProcessing" [disabled]="isSubmitting"
        (click)="goToPrevStep()">
        Prev
      </button>

      <!-- Step 2 -> Validate (triggers upload + polling, moves to step 3) -->
      <button class="btn btn-secondary text-white px-4" *ngIf="isSaveButtonEnabled && !isPreviewed"
        [disabled]="!uploadedFile || isSubmitting" (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Upload & Validate</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Uploading...</span>
      </button>

      <!-- Step 3: Processing -> allow minimize -->
      <button class="btn btn-outline-secondary px-4" *ngIf="isProcessing" (click)="minimizeProcessing()">
        Continue in background
      </button>

      <!-- Step 3: Processing -> view log toggle -->
      <button class="btn btn-link text-secondary text-nowrap text-decoration-none p-0" *ngIf="isProcessing"
        (click)="toggleProcessingLog()">
        {{ showProcessingLog ? 'Hide log' : 'View log' }}
      </button>

      <!-- Step 3 (validated) -> Proceed to Upload -->
      <button class="btn btn-success text-white px-4" *ngIf="isPreviewed && !uploadCompleted && !isProcessing"
        [disabled]="isSubmitting" (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Proceed to Upload</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Uploading...</span>
      </button>

      <!-- Upload finished -> Close -->
      <button class="btn btn-secondary text-white px-4" *ngIf="uploadCompleted" (click)="closeModal()">
        Done
      </button>

      <!-- Step 1 -> Step 2 -->
      <button class="btn btn-secondary text-white px-4" *ngIf="!isSaveButtonEnabled && !isPreviewed"
        [disabled]="!selectedCategoryID" (click)="goToNextStep()">
        Next
      </button>
    </div>
  </div>
</div>